{
  "platform": "Plateforme",
  "partner": "Partenaire",
  "tenants": "Locataires",
  "customers": "Clients",
  "partners": "Partenaires",
  "enquiries": "Demandes",
  "teamAccess": "Équipe et accès",
  "tenant": "Locataire",
  "yourTenants": "Vos locataires",
  "noTenantAssignments": "Aucune attribution de locataire pour le moment.",
  "noPartnerCustomersYet": "Ce partenaire n’a pas encore de clients.",
  "onboarding": "Intégration",
  "overview": "Aperçu",
  "users": "Utilisateurs",
  "groups": "Groupes",
  "designer": "Concepteur",
  "rules": "Règles",
  "campaigns": "Campagnes",
  "tester": "Testeur"
}
